import { useState, useEffect, useRef } from "react";
import { Control } from "./General";
import { SettingsGroup } from "./General";
import Button from '@mui/material/Button'
import { FaTrash } from "react-icons/fa";

export function FileControl( props )
{
    const name = props.name 
    const value = props.value 
    const setValue = props.setValue

    const setRemove = props.setRemove


    const [ selectedFile, setSelectedFile ] = useState(null)    
    const inputRef = useRef(null)

    const openFileDialog = () => {
        inputRef.current = document.createElement('input');
        inputRef.current.type = 'file';
        inputRef.current.onchange = _this => {
            let file = inputRef.current.files[0];
            setSelectedFile(file)
        };
        inputRef.current.click();
    }

    useEffect( () => {
        if(selectedFile == null)
        {
            return
        }

        var fr = new FileReader();

        fr.onload = function() {

            try {
                let content =  btoa(fr.result)
                var data = {}
                data.content = structuredClone(content)
                data.filename = structuredClone(selectedFile.name)
                data.filetype = structuredClone(selectedFile.type) + ";base64"

                setValue(data)
            }
            catch (err)
            {
                console.log(err)
            }
        }

        fr.readAsBinaryString(selectedFile);
    }, [selectedFile])

    const remove = () => {
        setValue(null)
        setRemove(true)
    }

    return (
        <div style={{ width:'100%', height: '31px', fontSize:'12px', backgroundColor:'#FFF', marginBottom:'5px'}} >
            <Control name={name}>
                <>
                    { value == null &&
                    <Button style={{ textTransform:'none', width:'100%'}} 
                            size="small"
                            onClick={openFileDialog}
                    >
                        Select an image
                    </Button>
                    }
                    { value != null &&
                    <div style={{ height:'100%', width:'100%', cursor:'pointer' }}>
                        <div style={{ height:'100%', width:'calc(100% - 40px)', float:'left', cursor:'pointer' }}
                             onClick={openFileDialog}
                        >
                            <img src={`data:${value.filetype}, ${value.content}`} 
                                 style={{ maxHeight: '100%', maxWidth: '100%' }}
                            />
                        </div>
                        <div className="d-flex justify-content-center align-items-center" 
                             style={{ height:'100%', width:'40px', float:'right', cursor:'pointer' }}
                             onClick={remove}
                        >
                            <FaTrash />
                        </div>

                    </div>
                    }
                </>
            </Control>
        </div>
    )
}

export function File( props )
{
    const data = props.data
    const key = props.id

    const files = props.files 
    const setFiles = props.setFiles

    const [ name, setName ] = useState(null)
    const [ value, setValue ] = useState(null)
    const [ type, setType ] = useState(null)

    const [ remove, setRemove ] = useState(false)

    useEffect( () => {
        if( data == null )
        {
            setName( null )
            setValue( null )
            setType( null )

            return
        }

        setName( data.name )
        setValue( data.value )
        setType( data.type )
    },[data])

    useEffect( () => {
        if( value == null )
        {
            return
        }

        let vv = structuredClone(files)
        vv[ data.key ] = value 
        setFiles(vv)
    },[value])

    useEffect( () => {
        if( remove == false )
        {
            return
        }

        let vv = structuredClone(files)
        delete vv[ data.key ]
        setFiles(vv)


        setRemove(false)


    },[remove])

    return (
        <FileControl name={name}
                     value={value}
                     setValue={setValue}
                     setRemove={setRemove}
        />
    )
}

export default function FilesModules( props )
{
    const files = props.files 
    const setFiles = props.setFiles 
    const filesList = props.filesList
    const reset = props.reset

    const [ data, setData ] = useState(null)

    const reload = () => {
        let d = []

        for( let file of filesList )
        {
            let var_ = structuredClone( file )
            var_.value = structuredClone( files[ var_.key ])
            
            d.push( var_ )
        }

        setData( d )
    }

    useEffect( () => {
        reload()
    },[reset])

    if( data == null )
    {
        return (<></>)
    }

    return (
        <SettingsGroup name="Files">
            { data.map( (file,idx) => 
            <File data={file}
                  name={file.name} 
                  id={file.key} 
                  key={idx} 
                  files={files} 
                  setFiles={setFiles}
            />
            )}
        </SettingsGroup>
    )

}


